module.exports = __webpack_public_path__ + "static/media/23_Bild_2_LEG_Team_OssurRheoKnee_NicolaPitaro_7953.e272fec1.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Particles/Particle23/23_Bild_2_LEG_Team_OssurRheoKnee_NicolaPitaro_7953.jpg
 ** module id = 166
 ** module chunks = 0
 **/